import {Component, OnInit} from "@angular/core"
import {NavigationStart, Router} from "@angular/router"
import {TranslateService} from "@ngx-translate/core"

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {

    private readonly isHashUrl = /^\/#/

    constructor(public router: Router,
                private readonly translate: TranslateService) {
        translate.setDefaultLang("zh")

        // if ("language" in navigator) {
        //     const language = navigator.language
        //     if (language.toLocaleLowerCase().startsWith("zh")) {
        //         translate.setDefaultLang("zh")
        //     } else {
        //         translate.setDefaultLang("en")
        //     }
        // } else {
        //     translate.setDefaultLang("en")
        // }
    }

    /*
     * This is a dirty hack that exists purely because the TF UI code sends people to /#/signin and
     * since we run multiple skins on the same code we can't just update where that sends us
     */
    public ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if ((event.url != null) && this.isHashUrl.test(event.url)) {
                    const targetUrl = event.url.replace("/#", "")
                    window.location.assign(targetUrl)
                }
            }
        })
    }
}
